function t(e) {
  return e.split("-")[0];
}
export {
  t as default
};
//# sourceMappingURL=design-system.es889.js.map
